// Chakra imports
import {Flex} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {RosterTable} from "./RosterTable";
import {searchRoster} from "./services";
import Bell from "./Bells/Bell";

function Tables(props) {

    const {selectedSchool} = props

    const [rosterList, setRosterList] = useState([])
    const [rosterLoading, setRosterLoading] = useState(true)
    const [isRosterPage, setIsRosterPage] = useState(true)

    const [activeRoster, setActiveRoster] = useState({})

    useEffect(() => {
        fetchRosterList(selectedSchool)
    }, []);


    const handleSetActiveRoster = (roster) => {
        setActiveRoster(roster)
    }

    const fetchRosterList = async (selectedSchool) => {
        setRosterLoading(true)
        try {
            let requestDTO = {
                schoolId: Number(selectedSchool),
                code: "",
                startDate: "",
                endDate: "",
            }
            const response = await searchRoster(requestDTO)
            if (response.status === 200) {
                setRosterList(response.data)
            }
        } catch (e) {
            console.log("Error while fetching roster list e:", e);
        } finally {
            setRosterLoading(false)
        }
    }
    return (
        <Flex direction='column' pt={{base: "120px", md: "75px"}}>
            {isRosterPage ?
                <RosterTable
                    setIsRosterPage={setIsRosterPage}
                    rosterList={rosterList}
                    handleSetActiveRoster={handleSetActiveRoster}
                    fetchRosterList={fetchRosterList}
                    isLoading={rosterLoading}
                    title={"Period Roster"}
                    selectedSchool={selectedSchool}
                    description={"Architects design houses"}/>
                :
                <Bell
                    activeRoster={activeRoster}
                />
            }
        </Flex>
    );
}

export default Tables;
